import ClickSyncProcessLogManagementClickSyncProcessLogListSlice from '../../slices/experiences/ClickSyncProcessLogManagementClickSyncProcessLogListSlice'
import ClickSyncProcessLogManagementClickSyncProcessLogListExportSlice from '../../slices/experiences/ClickSyncProcessLogManagementClickSyncProcessLogListExportSlice'

const ClickSyncProcessLogManagementExperienceActions = {
  list: ClickSyncProcessLogManagementClickSyncProcessLogListSlice.actions,
  exportList: ClickSyncProcessLogManagementClickSyncProcessLogListExportSlice.actions
}

export default ClickSyncProcessLogManagementExperienceActions
